import type { Token } from "@/domains/core"
import { LcAddress } from "@/domains/core"
import { TokenStore } from "@/domains/tokens/token-store"

/**
 * Convert TokenStore to Token format for legacy               component
 */
export function tokenStoreToToken(tokenStore: TokenStore): Token {
  // TokenStore.address is always LcAddress, but add safety check
  if (!tokenStore.address || typeof tokenStore.address.toViemAddress !== "function") {
    throw new Error(`Invalid TokenStore: address is not an LcAddress instance. Token: ${tokenStore.symbol}`)
  }
  
  return {
    address: tokenStore.address.toViemAddress(),
    symbol: tokenStore.symbol,
    name: tokenStore.name,
    decimals: tokenStore.decimals,
    balance: tokenStore.displayBalance,
    priceUsd: tokenStore.bestPrice,
    balanceUsdValue: Number(tokenStore.balanceValueUSD),
    isSwapToken: tokenStore.isSwapToken,
    isWhitelisted: tokenStore.isWhitelisted,
    isBribeToken: tokenStore.isIncentiveToken,
  }
}

/**
 * Convert array of TokenStore to array of Token
 */
export function tokenStoresToTokens(tokenStores: Array<TokenStore>): Array<Token> {
  return tokenStores.map(tokenStoreToToken)
}
